var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestFundsScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.489,
    height: 110,
    viewBox: "0 0 136.489 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 67.845,
    height: 64.972,
    fill: "#f07900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intro_7",
    "data-name": "Intro 7",
    transform: "translate(-24 -255.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M140.583,170.368c-29.031-1.277-31.934,11.491-59.351,6.7S48.975,134.3,65.1,117.065,81.188,82.744,108,71.741s55.6,4.563,72.73,29.348,12.949,51.244,2.849,60.421S169.613,171.645,140.583,170.368Z",
    transform: "translate(-31.889 187.436)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(58.322 278.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M67.413,144.928l-33.49,6.966L.432,144.928A.543.543,0,0,1,0,144.4V119.841a.542.542,0,0,1,.653-.531l33.269,6.92,33.269-6.92a.543.543,0,0,1,.653.531V144.4a.543.543,0,0,1-.432.531",
    transform: "translate(0 -86.923)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M104.157,52.9a9.041,9.041,0,1,1-11.7,5.157,9.041,9.041,0,0,1,11.7-5.157",
    transform: "translate(-66.918 -38.096)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M56.7,48.294a3.955,3.955,0,1,1-5.119,2.256A3.956,3.956,0,0,1,56.7,48.294",
    transform: "translate(-37.388 -34.991)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M41.154,36.477l1.681-.35-29.619-11.5L21.475,3.352,69.093,21.834l-3.729,9.607,3.167-.659,3.878-9.99a.543.543,0,0,0-.31-.7L20.433.037a.543.543,0,0,0-.7.309L9.9,25.673a.543.543,0,0,0,.31.7l20.347,7.9Z",
    transform: "translate(-7.187 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M172.384,101.679a3.957,3.957,0,0,0,.52.157l3.281-.683a3.93,3.93,0,0,0,1.4-1.957,3.956,3.956,0,1,0-5.2,2.483",
    transform: "translate(-123.762 -68.516)",
    fill: "#f07900"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFundsScreen);
export default __webpack_public_path__ + "static/media/request-funds-screen.873ad8770ecb1dc4a889afd65a0d63dc.svg";
export { ForwardRef as ReactComponent };